/**
 * Connection state management for Bifrost
 */

export class ConnectionState {
  private ready = false;
  private readyPromise: Promise<void>;
  private readyResolve!: () => void;

  constructor(private timeout: number) {
    this.readyPromise = new Promise<void>((resolve) => {
      this.readyResolve = resolve;
    });
  }

  /**
   * Ensure connection is ready, with timeout
   */
  async ensureReady(): Promise<void> {
    if (this.ready) {
      return Promise.resolve();
    }

    const timeoutPromise = new Promise<void>((_, reject) => {
      setTimeout(() => reject(new Error("Connection timeout")), this.timeout);
    });

    return Promise.race([this.readyPromise, timeoutPromise]);
  }

  /**
   * Mark connection as ready
   */
  setReady(): void {
    if (!this.ready) {
      this.ready = true;
      this.readyResolve();
    }
  }

  /**
   * Check if connection is ready
   */
  isReady(): boolean {
    return this.ready;
  }

  /**
   * Reset connection state (for testing/reconnection)
   */
  reset(): void {
    this.ready = false;
    this.readyPromise = new Promise<void>((resolve) => {
      this.readyResolve = resolve;
    });
  }
}
